export function buildLoadingSequence(plan) {
  const sequence = [];
  (plan?.pallets || []).forEach((pallet, palletIndex) => {
    (pallet?.boxes || []).forEach((box, boxIndex) => {
      sequence.push({
        palletIndex,
        palletNo: pallet?.pallet_no ?? palletIndex + 1,
        boxIndex,
        box,
      });
    });
  });

  return sequence.sort((a, b) =>
    a.palletIndex - b.palletIndex ||
    Number(a.box?.z || 0) - Number(b.box?.z || 0) ||
    Number(a.box?.y || 0) - Number(b.box?.y || 0) ||
    Number(a.box?.x || 0) - Number(b.box?.x || 0) ||
    a.boxIndex - b.boxIndex
  );
}

export function easeOutCubic(t) {
  const x = Math.max(0, Math.min(1, Number(t) || 0));
  return 1 - Math.pow(1 - x, 3);
}

export function buildSimulationPallet(plan, sequence, completedCount, progress = 0) {
  if (!sequence?.length) {
    const pallet = plan?.pallets?.[0];
    return pallet ? { palletIndex: 0, pallet: { ...pallet, boxes: [] }, active: null } : null;
  }

  const bounded = Math.max(0, Math.min(Number(completedCount) || 0, sequence.length));
  const active = bounded < sequence.length ? sequence[bounded] : null;
  const last = sequence[Math.max(0, Math.min(bounded - 1, sequence.length - 1))];
  const palletIndex = active?.palletIndex ?? last?.palletIndex ?? 0;
  const source = plan.pallets[palletIndex];
  const boxes = [];

  for (let i = 0; i < bounded; i += 1) {
    const entry = sequence[i];
    if (entry.palletIndex === palletIndex) boxes.push({ ...entry.box });
  }

  if (active && active.palletIndex === palletIndex) {
    const box = active.box;
    const t = easeOutCubic(progress);
    const startX = -Number(box.dx || 0) - 20;
    const startZ = Number(source?.H || plan?.pallet_H || 160) + 25;
    boxes.push({
      ...box,
      x: startX + (Number(box.x || 0) - startX) * t,
      y: Number(box.y || 0),
      z: startZ + (Number(box.z || 0) - startZ) * t,
      __simulationActive: true,
    });
  }

  return {
    palletIndex,
    pallet: {
      ...source,
      boxes,
      box_count: boxes.length,
    },
    active,
  };
}
